export const compareDateTimeStrings = (dateTimeString1, dateTimeString2) => {
  const dateTime1 = new Date(dateTimeString1)
  const dateTime2 = new Date(dateTimeString2)
  return dateTime1.getFullYear() !== dateTime2.getFullYear() ||
    dateTime1.getMonth() !== dateTime2.getMonth() ||
    dateTime1.getDate() !== dateTime2.getDate()
}